import { useTranslation } from "react-i18next";

export const useTranslator = () => {
    const { i18n } = useTranslation();
    const traslate = (value) => value?.[i18n.language]??"";
    return {
        t: i18n.t,
        i18n,
        traslate
    }
}